/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ShipmentItemRequest } from './ShipmentItemRequest';
export type ShipmentCreateRequest = {
    name: string;
    /**
     * draft | saved
     */
    workflowStatus?: ShipmentCreateRequest.workflowStatus;
    /**
     * Currency code (EUR/USD); omit to use account default from settings
     */
    currency?: ShipmentCreateRequest.currency | null;
    transportProfileId?: string | null;
    incoterm?: string | null;
    originCountryCode?: string | null;
    destinationCountryCode?: string | null;
    originCity?: string | null;
    destinationCity?: string | null;
    /**
     * ETA date (YYYY-MM-DD)
     */
    eta?: string | null;
    warehouseComment?: string | null;
    plannedTransport?: number | null;
    plannedDuty?: number | null;
    plannedClearance?: number | null;
    plannedEnergyTax?: number | null;
    plannedOther?: number | null;
    items?: Array<ShipmentItemRequest> | null;
    labelIds?: Array<string> | null;
    trackingUrl?: string | null;
};
export namespace ShipmentCreateRequest {
    /**
     * draft | saved
     */
    export enum workflowStatus {
        DRAFT = 'draft',
        SAVED = 'saved',
    }
    /**
     * Currency code (EUR/USD); omit to use account default from settings
     */
    export enum currency {
        EUR = 'EUR',
        USD = 'USD',
    }
}

